import * as t from 'io-ts';
import { decode } from '../../../common/decodingUtils/iotsDecoder';

const localStorageCodec = t.type({
    showWorkingTimesInfoBox: t.boolean,
});
export type LocalStorageState = t.TypeOf<typeof localStorageCodec>;

export const decodeLocalStorage = (parsedObject: unknown): LocalStorageState => decode(parsedObject, localStorageCodec);
